/**
 * Ticket status lists shared by the Ready to Bill hook and the Service Invoicing model (pure, no Firebase import).
 * READY mirrors READY_TO_BILL_STATUSES in functions/src/billing/services/ticketBillingService.ts: the server refuses
 * any other status, so a drift here shows a row whose action will fail. Compared EXACTLY, never trimmed or case-folded.
 */
export const READY_TO_BILL_STATUSES = ['5 Completed', '6 Reviewed'] as const;

/** Terminal statuses: billed, declined, cancelled. Never open work. */
export const CLOSED_TICKET_STATUSES = ['7 Billed', '8 Declined', '9 Cancelled'] as const;

/** Earlier-stage statuses: open work that is not yet ready to bill. A WHITELIST: an unknown status is never "open work". */
export const OPEN_TICKET_STATUSES = [
  '0 System Generated', '0 User Generated', '1.1 To Quote', '1.2 Quote Sent', '1.3 Quote Approved', '1.4 Preparing Job',
  '1.5 Ready to Schedule', '2 Attempting to Schedule', '3 Confirmed', '4.1 Dispatched', '4.2 In Progress', '4.3 Reports Due',
] as const;
